var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseExportContact",
    { attrs: { showSelectBuilding: false, postFixer: "work-permits" } },
    [
      _c(
        "HKLForm",
        {
          ref: "formRef",
          staticClass: "export-work-permits-search",
          attrs: { slot: "addtional-content" },
          slot: "addtional-content",
        },
        [
          _c(
            "div",
            { staticClass: "issue-date-range" },
            [
              _c(
                "label",
                { staticClass: "emphasis ad-search-condition-label" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("project.building")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("HKLMultiSelect", {
                staticClass: "check-valid building-option",
                attrs: {
                  required: true,
                  showTip: false,
                  options: _vm.buildingOptions,
                },
                model: {
                  value: _vm.selectedBuildings,
                  callback: function ($$v) {
                    _vm.selectedBuildings = $$v
                  },
                  expression: "selectedBuildings",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }